var _style, _polygon, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000140000830326188122060000013239372036337685676_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 29",
    style: {
      enableBackground: "new 0 0 29 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-opacity:0;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "21,14 15,14 15,8 14,8 14,14 8,14 8,15 14,15 14,21 15,21 15,15 21,15 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 29,
    height: 29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon-add.5404c16e13ae53122e3f786b91321eb1.svg";
export { ForwardRef as ReactComponent };